export default "__VITE_ASSET__cc336eeb__$_?nuxt_component=async__"